/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { useMemo } from 'react';

import * as remixIcons from '@remixicon/react';

import { StyContainerIcon } from './styles';
import * as customIcons from './CustomIcons';

interface ICustomIconProps {
  type: string;
  id?: string;
  size?: string | number;
  color?: string;
  onClick?: () => void;
}

export const Icon = ({
  type,
  id,
  size,
  color,
  onClick,
  ...rest
}: ICustomIconProps) => {
  const formatIconName = (iconName: string) =>
    `Ri${iconName
      .replace(/-(.)/g, (_, char) => char.toUpperCase())
      .replace(/^./, (char) => char.toUpperCase())}`;

  const refixedSize = useMemo(
    () => (typeof size === 'number' ? `${size}px` : size),
    [size]
  );

  const iconName = formatIconName(type);
  const RemixIcons: any = remixIcons[iconName as keyof typeof remixIcons];

  if (RemixIcons) {
    return (
      <StyContainerIcon id={id} $hasOnClick={!!onClick} onClick={onClick}>
        <RemixIcons size={refixedSize} color={color} {...rest} />
      </StyContainerIcon>
    );
  }

  const formatCustomIconName = (iconName: string) =>
    iconName
      .replace(/-(.)/g, (_, char) => char.toUpperCase())
      .replace(/^./, (char) => char.toUpperCase());

  const iconCustomName = formatCustomIconName(type);
  const CustomIcon = customIcons[iconCustomName as keyof typeof customIcons];

  if (CustomIcon) {
    return (
      <StyContainerIcon id={id} $hasOnClick={!!onClick} onClick={onClick}>
        <CustomIcon width={refixedSize} color={color} {...rest} />
      </StyContainerIcon>
    );
  }

  return null;
};
